var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgThumbDownSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0932 19.7009C10.0932 20.3913 10.6529 20.9509 11.3432 20.9509H12.0695C13.1866 20.9509 14.1345 20.1313 14.2959 19.0259L14.7337 16.0266C14.7516 15.9038 14.8569 15.8127 14.981 15.8127H18.3942C19.8267 15.8127 20.8944 14.4918 20.5942 13.0911L18.9029 5.20168C18.6805 4.16437 17.7638 3.42331 16.7029 3.42331H8.31299C8.33941 3.54421 8.35333 3.66977 8.35333 3.79858V14.6228C8.35333 14.7116 8.34671 14.7989 8.33394 14.8842L8.89582 15.1816C9.63247 15.5715 10.0932 16.3367 10.0932 17.1702V19.7009Z",
    fill: "#323544"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60352 15.373H4.60352C3.91316 15.373 3.35352 14.8134 3.35352 14.123V4.29883C3.35352 3.60847 3.91316 3.04883 4.60352 3.04883H6.62284C7.02812 3.05908 7.35352 3.39083 7.35352 3.79858V14.6228C7.35352 15.037 7.01773 15.373 6.60352 15.373Z",
    fill: "#323544"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDownSelected);
export default __webpack_public_path__ + "static/media/thumb-down-selected.33604b0988e36146104f2c501ae65004.svg";
export { ForwardRef as ReactComponent };